// Звук входящего сообщения. Защита от спама: оператор может слать сообщения
// очередью — звук должен играть с минимальным интервалом, иначе он "захлёбывается".
import messageAudioUrl from '../assets/message.m4a';

const MIN_INTERVAL_MS = 1500;
const VOLUME = 0.5;

let audio: HTMLAudioElement | null = null;
let lastPlayAt = 0;

function getAudio(): HTMLAudioElement | null {
  if (typeof Audio === 'undefined') return null;
  if (!audio) {
    try {
      audio = new Audio(messageAudioUrl);
      audio.preload = 'auto';
      audio.volume = VOLUME;
    } catch {
      return null;
    }
  }
  return audio;
}

export function playIncomingSound(): void {
  const now = Date.now();
  if (now - lastPlayAt < MIN_INTERVAL_MS) return;
  lastPlayAt = now;

  const a = getAudio();
  if (!a) return;
  try {
    a.currentTime = 0;
    // Autoplay policy: до первого user-interaction браузер может отклонить play().
    // Не критично — пользователь уже открыл виджет, обычно interaction уже был.
    void a.play().catch(() => {
      /* autoplay-policy / network-error — игнорируем */
    });
  } catch {
    /* ignore */
  }
}
